import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  num: '01',
  tag: 'Pronto in 5 minuti',
  icon: '🧪',
  title: '50 Attività di Laboratorio Pronte',
  desc: 'Esercitazioni pratiche passo-passo su KNX, Zigbee, Home Assistant e IoT. Apri, stampa, insegna.'
}, {
  num: '02',
  tag: 'Standard 2026',
  icon: '🚀',
  title: 'Tecnologia Aggiornata al 2026',
  desc: 'Materiali costruiti sugli ultimi standard europei: Matter 1.3, Thread, EN 15232 e Cyber Resilience Act.'
}, {
  num: '03',
  tag: 'LIM Ready',
  icon: '🖥️',
  title: 'Slide per la LIM già pronte',
  desc: 'Lezioni digitali professionali per spiegare la teoria complessa in modo visuale e immediato.'
}, {
  num: '04',
  tag: 'EQF 4-5',
  icon: '🎓',
  title: 'Metodologia EQF 4-5',
  desc: 'Griglie di valutazione, verifiche e cronogrammi allineati al quadro europeo delle qualifiche professionali.'
}];
export function Benefits() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <p className="text-center text-xs font-black tracking-widest text-brand-orange uppercase mb-3" data-id="element-21">
          Cosa otterrai
        </p>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-3 text-brand-cream" data-id="element-22">
          Tutto quello che serve per insegnare{' '}
          <span className="text-brand-orange" data-id="element-23">domotica</span> senza più stress.
        </motion.h2>
        <p className="text-center text-gray-400 text-sm mb-8 max-w-2xl mx-auto" data-id="element-24">
          Quattro pilastri pensati per farti risparmiare ore e far brillare il
          tuo corso.
        </p>

        <div className="grid grid-cols-1 gap-4" data-id="element-25">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-brand-card border border-brand-orange/20 p-6 rounded-2xl hover:border-brand-orange/50 transition-all relative overflow-hidden" data-id="element-26">
              <div className="absolute -right-3 -top-3 text-6xl font-black text-white/5" data-id="element-27">
                {b.num}
              </div>
              <div className="relative z-10" data-id="element-28">
                <div className="inline-block bg-brand-orange/10 border border-brand-orange/30 text-brand-orange text-[10px] font-black px-2.5 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-29">
                  {b.tag}
                </div>
                <div className="flex items-start gap-3 mb-2" data-id="element-30">
                  <span className="text-3xl" data-id="element-31">{b.icon}</span>
                  <h3 className="text-lg sm:text-xl font-bold text-brand-cream leading-tight" data-id="element-32">
                    {b.title}
                  </h3>
                </div>
                <p className="text-gray-400 text-sm font-medium leading-relaxed" data-id="element-33">
                  {b.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}